import React, { Component } from 'react'
import { Link } from 'react-router'
import { connect } from 'react-redux'
import { push } from 'react-router-redux'

import classNames from './Home.css'
import { createImageGetter } from '../utils/images'
import { mapStateToLists } from '../utils/lists'
import { userHasPerm } from '../utils/auth'
import { fetchAlbums } from '../redux/albums'
import { fetchPlaylists } from '../redux/playlists'
import AlbumList from '../components/album/AlbumList'
import Welcome from '../components/home/Welcome'
import FeaturedAlbum from '../components/home/FeaturedAlbum'
import LoadingSpinner from '../components/LoadingSpinner'
import ErrorMessage from '../components/ErrorMessage'
import EmptyNotice from '../components/EmptyNotice'

const cache = {
  welcomeSeen: false
}

class Home extends Component {
  state = {
    welcomeSeen: cache.welcomeSeen
  }
  componentDidMount () {
    const { data, fetchAlbums, lists, fetchPlaylists } = this.props
    if (!data) {
      fetchAlbums()
    }
    if (!lists) {
      fetchPlaylists()
    }
  }
  onCloseWelcome = () => {
    cache.welcomeSeen = true
  }
  renderList (heading, albums, id) {
    if (!albums || albums.length === 0) {
      // No albums, but we still want to show when
      // id is 'all' and user can search
      if (!this.props.canSearch || id !== 'all') {
        return null
      }
    }
    const href = `/group/${id}`
    return [
      <h2 key='heading' className={classNames.heading}>
        <Link to={href}>
          {heading}
        </Link>
      </h2>,
      <AlbumList
        key='list'
        albums={albums}
        moreLink={href}
        getImageSource={this.props.getImageSource}
        getAlbumInfo={this.props.getAlbumInfo}
        isFavourite={this.props.isFavourite}
        viewAlbum={this.props.viewAlbum}
        editAlbum={this.props.editAlbum}
        showCreateAlbum={id === 'all'}
      />
    ]
  }
  renderCustomList = list => {
    const structure = JSON.parse(list.json_data)
    if (structure.playlistsOnly) {
      return null
    }
    return this.renderList(list.name, list.albums, list.id)
  }
  render () {
    const { route, mine, fetching, lists, error, fetchAlbums } = this.props

    if (route.showFeaturedAlbum && (this.props.showWelcome || this.props.showWelcomeSharing) && !this.state.welcomeSeen) {
      return (
        <Welcome
          onClose={this.onCloseWelcome}
          canSearch={this.props.canSearch}
          canShare={this.props.canShare}
          shareOnly={this.props.showWelcomeSharing}
        />
      )
    }

    if (!mine || !lists || fetching) {
      return (
        <div className={classNames.loadingWrapper}>
          <LoadingSpinner />
        </div>
      )
    }

    if (error) {
      <ErrorMessage
        message='There was an error fetching the albums'
        onRetry={fetchAlbums}
      />
    }

    const { getImageSource, shared, recent, favourites } = this.props

    const noAlbums = arraysAreEmpty(lists, favourites, shared, mine, recent)
    const albumsWithCovers = mine.filter(album => album.cover)
    const emptyHome = noAlbums && !this.props.canSearch

    return (
      <div>
        {route.showFeaturedAlbum && albumsWithCovers.length !== 0 &&
          <FeaturedAlbum
            albums={albumsWithCovers}
            getImageSource={getImageSource}
          />
        }
        {route.showFeaturedAlbum && mine.length === 0 &&
          <div className={classNames.fakeHeader} />
        }
        <div className={classNames.page}>
          {!emptyHome &&
            <Link to='/groups' className={classNames.editListsLink}>
              Manage album groups
            </Link>
          }
          {!emptyHome &&
            <h1 className={classNames.title}>
              Albums
            </h1>
          }
          {emptyHome &&
            <EmptyNotice
              heading='Shared albums will appear here'
              text='Albums will appear here when other users share with you.'
            />
          }
          {lists.map(this.renderCustomList)}
          {this.renderList('Favourites', favourites, 'favourites')}
          {this.renderList('Shared with me', shared, 'shared')}
          {this.renderList('Recent', recent, 'recent')}
          {this.renderList('All albums', mine, 'all')}
        </div>
      </div>
    )
  }
}

const mapStateToProps = ({ albums, playlists, entities, auth, nav }) => {
  const fromLogin = nav.previousPath === '/login'
  const denormalize = id => entities.albums[id]
  const all = (albums.all.data || []).map(denormalize)
  const mine = all.filter(a => a.user_id === auth.user.id).filter(filterAlbum)
  const sharedImages = mine.filter(a => a.image_share)
  const favouriteImages = mine.filter(a => a.favourite)
  const daysSinceLastLogin = auth.user.last_login && (new Date() - new Date(auth.user.last_login)) / 1000 / 60 / 60 / 24
  return {
    data: albums.all.data,
    mine,
    shared: sharedImages.concat(all.filter(a => a.user_id !== auth.user.id)),
    recent: all.filter(filterAlbum).filter(filterRecent).sort(sortRecent),
    favourites: favouriteImages.concat((albums.favourites.data || []).map(denormalize)),
    fetching: albums.all.fetching || albums.favourites.fetching || playlists.fetching,
    error: albums.all.error || albums.favourites.error,
    getImageSource: createImageGetter(auth),
    lists: mapStateToLists(playlists, entities),
    isFavourite: id => (albums.favourites.data || []).indexOf(id) !== -1,
    canSearch: userHasPerm(auth.user, 'search_and_save'),
    canShare: userHasPerm(auth.user, 'internal_share') || userHasPerm(auth.user, 'external_share'),
    getAlbumInfo: album => {
      if (album.user_id === auth.user.id || !entities.users[album.user_id]) return null
      const user = entities.users[album.user_id]
      return `by ${user.name}`
    },
    showWelcome: fromLogin && auth.user.count_login <= 3 || daysSinceLastLogin > 30,
    showWelcomeSharing: fromLogin && auth.user.count_login > 0 && auth.user.count_login % 20 === 0
  }
}

function filterAlbum (album) {
  if (album.image_share || album.favourite) {
    return JSON.parse(album.json_data).include.length !== 0
  }
  return true
}

function filterRecent (album) {
  const date = new Date()
  date.setDate(date.getDate() - 7)
  return new Date(album.created_at) > date || new Date(album.updated_at) > date
}

function sortRecent (a, b) {
  a = a.updated_at || a.created_at
  b = b.updated_at || b.created_at
  return new Date(b) - new Date(a)
}

function arraysAreEmpty (...arrays) {
  for (let array of arrays) {
    if (array.length !== 0) {
      return false
    }
  }
  return true
}

const mapDispatchToProps = {
  fetchAlbums,
  fetchPlaylists,
  viewAlbum: id => dispatch => dispatch(push(`/album/${id}`)),
  editAlbum: id => dispatch => dispatch(push(`/album/${id}/edit`))
}

export default connect(mapStateToProps, mapDispatchToProps)(Home)



// WEBPACK FOOTER //
// ./src/pages/Home.js